import React from "react";
import { Container, Image, H3, ADImage } from "../../style/Header";
import Photo from "../../assets/demo.jpg";
import { CustomDiv } from "../../style/shared";
import { subject } from "../../service";
import AdvertiserCard from "../common/card";

import MedizenCreative from "../NewCreatives/MedizenCreative/MedizenCreative";
import Mycontext from "../../store/Mycontext";
import { htmls } from "../../constants";

export class Header extends React.Component {
  imgsrc = "Ads/Horizontal1.jpeg";

  constructor(props) {
    super(props);
    this.adConfig = localStorage.getItem("creativeConfig") ? JSON.parse(localStorage.getItem("creativeConfig")) : null;
  }

  componentDidMount() {
    this.subscription = subject.subscribe((res) => {
      this.imgsrc = res.headerImg;
      this.useImgSrc = res.useThis;
      this.forceUpdate();
    });
  }

  componentWillUnmunt() {
    this.subscription.unsubscribe();
  }

  
  static contextType = Mycontext;
  render() {
    const { CustomBanner } = this.props;
    const randValue = parseInt(window.sessionStorage.getItem("rValue"));
    const getRandomHoriCreative = () => {
      const withCta = this.adConfig.creative_cta === "With CTAs";
      if(!this.adConfig) return;

      if (withCta) {
        if (randValue === 1) {
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.MedizenHoriAddWithCTARep;
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.MedizenHoriAddWithCTASample;
          return htmls.MedizenHoriAddWithCta;
        }
        if (randValue === 2) {
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.PrimeraHoriAddWithCTARep;
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.PrimeraHoriAddWithCTASample;
          return htmls.PrimeraHoriAddWithCTA;
        }
        if (randValue === 3) {
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.PanazHoriAddWithCTASample;
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.PanazHoriAddWithCTARep;
          return htmls.PanazHoriAddWithCta;
        }
      } else {
        if (randValue === 1) {
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.MedizenHoriAddWithoutCTASample;
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.MedizenHoriAddWithoutCTARep;
          return htmls.MedizenHoriAddWithoutCTA;
        }
        if (randValue === 2) {
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.PrimeraHoriAddWithoutCTARep;
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.PrimeraHoriAddWithoutCTASample;
          return htmls.PrimeraHoriAddWithoutCTA;
        }
        if (randValue === 3) {
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.PanazHoriAddWithoutCTASample;
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.PanazHoriAddWithoutCTARep;
          return htmls.PanazHoriAddWithoutCTA;
        }
      }
    };

    return (
      <Container>
        <Image src={Photo} alt="photo" />
        <div style={{ marginLeft: "0px" }}>
          <H3>
            Patient : <span style={{ color: "#4678ED" }}>Phil Belford</span>{" "}
          </H3>
          <H3>DOB : 1972-02-09 Age : 49</H3>
        </div>
        {/* <CustomDiv>{this.useImgSrc ?<img src={this.imgsrc} />:<img src={CustomBanner} alt="adBanner"/>
}</CustomDiv> */}
        <CustomDiv style={{width:"740px"}}>
          {
            <iframe
              style={{ height: '100%', width: '100%' }}
              srcDoc={CustomBanner ? getRandomHoriCreative() : null}
            />
          }
        </CustomDiv>
        {/* <img src={CustomBanner} alt="adBanner"/> */}
      </Container>
    );
  }
}
